<template>
  <q-card square class="sticky-header-card">
    <div class="center-sticky-header">
      <location-sub-menu class="sticky-margin"></location-sub-menu>
      <div class="sticky-sub-menu">
        <div class="filter-info">
          Filters:
          <q-badge
            v-if="!selectedCompany || !selectedCompany.name"
            color="negative"
            >NONE</q-badge
          >
          <q-badge
            style="margin-right:5px"
            outline
            color="positive"
            v-if="selectedCompany && selectedCompany.name"
            >Company :
            {{
              selectedCompany && selectedCompany.name
                ? selectedCompany.name
                : ""
            }}</q-badge
          >
        </div>
        <div class="sticky-add">
          <q-btn
            round
            @click="$store.commit('location/SET_ADD', true)"
            color="red"
            size="xs"
          >
            <q-icon name="fas fa-plus" style="margin-top:3px"></q-icon>
          </q-btn>
        </div>
        <q-icon
          color="grey-7"
          @click="subMenu = true"
          name="fas fa-caret-down"
          class="cursor-pointer"
          size="25px"
        ></q-icon>

        <q-dialog
          v-model="subMenu"
          persistent
          transition-show="scale"
          transition-hide="scale"
        >
          <q-card style="width: 300px">
            <div class="bg-primary text-white sub-menu-title">
              <div class="text-h6">Filters</div>

              <q-icon
                @click="subMenu = false"
                name="fas fa-times"
                class="cursor-pointer"
              ></q-icon>
            </div>
            <location-sub-menu class="sub-menu-filters">
              <template v-slot:activator>
                <q-btn
                  label="Close"
                  size="md"
                  @click="subMenu = false"
                  color="negative"
                  style="margin-top:5px;width:100%"
                ></q-btn>
              </template>
            </location-sub-menu>
          </q-card>
        </q-dialog>
      </div>
    </div>
  </q-card>
</template>

<script>
import axios from "../axios/index";
import LocationSubMenu from "./LocationSubMenu";
export default {
  data() {
    return {
      subMenu: false,
    };
  },
  computed: {
    locations() {
      return this.$store.state.location.locations;
    },
    selectedCompany: {
      get() {
        return this.$store.state.location.selectedCompany;
      },
      set(val) {
        this.$store.commit("location/SET_SELECTED_COMPANY", val);
      },
    },
  },
  components: {
    LocationSubMenu,
  },
};
</script>
